import React from 'react';
import type { IconProps } from '../types';

export const HamburgerMenu = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    aria-hidden="true"
    {...props}
  >
    <rect
      x="2"
      y="4"
      width="16"
      height="2"
      rx="1"
    />
    <rect
      x="2"
      y="9"
      width="16"
      height="2"
      rx="1"
    />
    <rect
      x="2"
      y="14"
      width="16"
      height="2"
      rx="1"
    />
  </svg>
);

export default HamburgerMenu;
